module.exports = __webpack_public_path__ + "static/profile-63870b21486bc3520a0f1aa7cdd35757.png";